import React, { useState } from 'react'
import { Box, MenuItem, TextField, Typography } from '@mui/material'
import { SkillTranslation } from '../../../../api/types/character'
import { chunks } from '../../../../utils'
import { IEffect } from '../../../../api/types/effect'

interface Props {
  effect?: IEffect
  register: any
}

export const SkillModifiers: React.FC<Props> = ({ effect, register }) => {
  const [skills, setSkills] = useState<[string, number][]>(
    Object.entries(effect?.skill_stat || {})
      .filter(s => s[1] !== 0)
      .filter(s => s[0] !== 'id')
  )

  return (
    <Box sx={{ marginBottom: '8px' }}>
      <Typography variant="button" display="block" gutterBottom>
        Modyfikatory umiejętności
      </Typography>

      {effect?.skill_stat?.id && (
        <input
          type="hidden"
          name="effect_attributes.skill_stat_attributes.id"
          value={effect?.skill_stat?.id}
          ref={register()}
        />
      )}

      {skills.length < Object.keys(SkillTranslation).length && (
        <Box sx={{ display: 'flex', marginBottom: '8px', marginLeft: '4px', marginRight: '4px' }}>
          <TextField
            select
            fullWidth={true}
            label="Dodaj modyfikator umiejętności"
            value=""
            onChange={e => {
              e.preventDefault()
              setSkills(prevState => {
                if (!prevState.map(s => s[0]).includes(e.target.value)) {
                  return [[e.target.value, 1], ...prevState]
                }
                return [...prevState]
              })
            }}
          >
            {Object.entries(SkillTranslation)
              .filter(skill => !skills.map(s => s[0]).includes(skill[0]))
              .map(skill => (
                <MenuItem key={skill[0]} value={skill[0]}>
                  {skill[1]}
                </MenuItem>
              ))}
          </TextField>
        </Box>
      )}

      {skills &&
        chunks(skills.sort(), 4).map((group: [string, number][]) => (
          <Box key={JSON.stringify(group)} sx={{ display: 'flex', marginBottom: '8px' }}>
            {group.map(skill => (
              <TextField
                key={`effect_attributes.skill_stat_attributes.${skill[0]}`}
                sx={{ marginRight: '4px', marginLeft: '4px' }}
                type={'number'}
                fullWidth={true}
                name={`effect_attributes.skill_stat_attributes.${skill[0]}`}
                defaultValue={skill[1]}
                label={SkillTranslation[skill[0]] || skill[0]}
                variant="outlined"
                inputProps={{
                  ref: register(),
                }}
                onBlur={e =>
                  setSkills(prevState => [
                    ...prevState.filter(s => s[0] !== skill[0]),
                    [skill[0], Number(e.target.value)],
                  ])
                }
              />
            ))}
          </Box>
        ))}
    </Box>
  )
}
